<template>
  <v-dialog
    v-model="show"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <div id="app">
      <v-app id="inspire">
        <v-card color="#FFFF99">
          <v-card-title>
            <v-btn icon @click="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <h6>Listado de Datos de Empleados</h6>
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row>
              <v-col cols="6" sm="6" md="3">
                <v-text-field
                  label="Filtro por Legajo"
                  dense
                  v-model="filtrolegajo"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-text-field
                  label="Filtro por Nombre"
                  dense
                  v-model="filtronombre"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-text-field
                  label="Filtro por obra social"
                  dense
                  v-model="filtroobrasocial"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-text-field
                  label="Filtro por Grupo Sanguíneo"
                  dense
                  v-model="filtrogrupo"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="space-around">
              <v-btn
                tile
                color="success"
                @click="
                  cargarListado(
                    filtrolegajo,
                    filtronombre,
                    filtroobrasocial,
                    filtrogrupo
                  )
                "
              >
                <v-icon left> mdi-magnify </v-icon>
                Buscar
              </v-btn>
              <v-btn icon @click="exportarPDF">
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
        <v-data-table
          dense
          :headers="headers"
          :items="listadopersonal"
          locale="es-ar"
          class="elevation-1"
          :items-per-page="200"
          :footer-props="{
            itemsPerPageText: 'Empleados por página',
          }"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="blue"
                  class="mr-2"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarInforme(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <EditarInforme
          :visible="showInforme"
          :leg="editedItem.legajo"
          :id="editedItem.id"
          @close="showInforme = false"
        ></EditarInforme>
      </v-app>
    </div>
  </v-dialog>
</template>

<script>
import axios from "../../../src/axios-auth";
import EditarInforme from "../Medicina/Editardatos.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  components: { EditarInforme },
  data: (vm) => ({
    editedItem: {},
    editedIndex: -1,
    filtrolegajo: "",
    filtronombre: "",
    filtroobrasocial: "",
    filtrogrupo: "",
    listadopersonal: [],
    showInforme: false,
    headers: [
      { text: "ID", value: "id", align: " d-none", sortable: false },
      {
        text: "Legajo",
        align: "start",
        sortable: false,
        value: "legajo",
      },
      { text: "Nombre", value: "nombre", sortable: false },
      { text: "Fecha Nac.", value: "fnacimiento", sortable: false },
      { text: "DNI", value: "dni", sortable: false },
      { text: "Grupo S.", value: "grupo", sortable: false },
      { text: "Obra Social", value: "obrasocial", sortable: false },
      { text: "Afiliado", value: "afiliado", sortable: false },
      { text: "Tel. O. Social", value: "telosocial", sortable: false },
      { text: "Tel Personal", value: "telpersonal", sortable: false },
      { text: "Dirección", value: "direccion", sortable: false },
      { text: "Contacto", value: "contacto", sortable: false },
      { text: "Acciones", value: "actions", align: "center", sortable: false },
    ],
  }),

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarInforme();
          this.$emit("close");
        }
      },
    },
  },
  props: ["visible"],
  methods: {
    vaciarInforme() {
      this.listadopersonal = [];
    },
    editarInforme(item) {
      this.editedIndex = this.listadopersonal.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showInforme = true;
    },

    cargarListado() {
      const legajo = this.filtrolegajo;
      const nombre = this.filtronombre;
      const obrasocial = this.filtroobrasocial;
      const grupo = this.filtrogrupo;
      let self = this;
      axios
        .get("/Medico/ListadoPersonal?", {
          params: {
            legajo: legajo,
            nombre: nombre,
            obrasocial: obrasocial,
            grupo: grupo,
          },
        })
        .then((response) => {
          self.listadopersonal = response.data;
        })
        .catch((error) => {
          self.listadopersonal = [];
          console.log(error);
        });
    },
    exportarPDF() {
      var vm = this;
      var columnsM = [
        { title: "Legajo", dataKey: "legajo" },
        { title: "Nombre", dataKey: "nombre" },
        { title: "DNI", dataKey: "dni" },
        { title: "F. Nacimiento", dataKey: "fnacimiento" },
        { title: "Grupo S.", dataKey: "grupo" },
        { title: "Obra Social", dataKey: "obrasocial" },
        { title: "Afiliado", dataKey: "afiliado" },
        { title: "Tel O. Social", dataKey: "telosocial" },
        { title: "Tel Personal", dataKey: "telpersonal" },
        { title: "Dirección", dataKey: "direccion" },
        { title: "Contacto", dataKey: "contacto" },
      ];

      var doc = new jsPDF();
      doc.setFontSize(10);

      doc.text("LISTADO DE DATOS PERSONALES ", 15, 20);

      doc.autoTable(columnsM, vm.listadopersonal, { margin: { top: 25 } });

      doc.save("ListadoPersonal.pdf");
    },
  },
};
</script>
